export const pushToDataLayer = (data: Record<string, any>) => {
  // Ověření, že kód běží na straně klienta
  if (import.meta.client) {

    // Zajištění existence dataLayer, inicializací na prázdné pole, pokud je undefined
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    // Provedení push
    window.dataLayer.push(data);
  }
};
